import { render, staticRenderFns } from "./TradeAccountItem.vue?vue&type=template&id=8c8e4c12&lang=pug"
import script from "./TradeAccountItem.vue?vue&type=script&lang=js"
export * from "./TradeAccountItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports